import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Select from 'components/ui/Select';
import FormattedCurrency from 'components/ui/FormattedCurrency';

import { SummaryBlock, Paragraph } from './Product.styles';

const Product = ({ product: { name, code, quantity, price, total, currency }, editable, onChange }) => {
  const [input, setInput] = useState(quantity);

  const handleChange = (event) => {
    const newQuantity = Number(event.target.value);
    setInput(newQuantity);
    onChange(newQuantity);
  };

  return (
    <SummaryBlock>
      <Paragraph>
        <strong>{name}</strong>
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.code" />: {code}
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.quantity" />:{' '}
        {!editable ? (
          quantity
        ) : (
          <Select value={input} onChange={handleChange} required>
            {[...Array(quantity).keys()].map((x) => (
              <option key={x} value={x + 1}>
                {x + 1}
              </option>
            ))}
          </Select>
        )}
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.cost" />: <FormattedCurrency amount={Math.abs(price)} currency={currency} />
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.totalCost" />:{' '}
        <FormattedCurrency amount={total ? Math.abs(total) : Math.abs(price)} currency={currency} />
      </Paragraph>
    </SummaryBlock>
  );
};

Product.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.number,
    currency: PropTypes.string,
    total: PropTypes.number
  }),
  editable: PropTypes.bool,
  onChange: PropTypes.func
};

export default Product;
